// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateUser_page__TDDiq {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.CreateUser_topGrid__rQujk {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}
.CreateUser_cardTitle__L1epK {
  font-size: 24px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0 0 18px;
}
.CreateUser_detailGrid__4VNsc {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
}
.CreateUser_field__SXihJ {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.CreateUser_label__BIdge {
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
.CreateUser_clientField__iXypb {
  margin-top: 16px;
}
.CreateUser_fieldErr__Kw\\+UC {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: var(--dylo-danger);
}
.CreateUser_alert__3k3ii {
  margin-top: 16px;
  padding: 11px 16px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);
  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);
  color: var(--dylo-danger);
  font-size: 13px;
}
.CreateUser_createBtn__uVd4o {
  margin-top: 20px;
  background: var(--dylo-orange) !important;
  border: none !important;
}
.CreateUser_createBtn__uVd4o:hover:not(:disabled) {
  background: var(--dylo-orange-hover) !important;
}
.CreateUser_permHint__2DxSb {
  font-size: 13.5px;
  color: var(--dylo-muted);
  margin: 0;
}

/* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` la columna no baja del ancho mínimo de un campo, que en el
   iPhone es más ancho que en Chromium, y la forma se salía de la tarjeta (lo que le pasaba al login). */
@media (max-width: 1000px) {
  .CreateUser_topGrid__rQujk {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 560px) {
  .CreateUser_detailGrid__4VNsc {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/CreateUser/CreateUser.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yEAAyE;EACzE,mEAAmE;EACnE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;wGACwG;AACxG;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.topGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  align-items: start;\n}\n.cardTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0 0 18px;\n}\n.detailGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 20px;\n}\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n.label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.clientField {\n  margin-top: 16px;\n}\n.fieldErr {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--dylo-danger);\n}\n.alert {\n  margin-top: 16px;\n  padding: 11px 16px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);\n  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);\n  color: var(--dylo-danger);\n  font-size: 13px;\n}\n.createBtn {\n  margin-top: 20px;\n  background: var(--dylo-orange) !important;\n  border: none !important;\n}\n.createBtn:hover:not(:disabled) {\n  background: var(--dylo-orange-hover) !important;\n}\n.permHint {\n  font-size: 13.5px;\n  color: var(--dylo-muted);\n  margin: 0;\n}\n\n/* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` la columna no baja del ancho mínimo de un campo, que en el\n   iPhone es más ancho que en Chromium, y la forma se salía de la tarjeta (lo que le pasaba al login). */\n@media (max-width: 1000px) {\n  .topGrid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 560px) {\n  .detailGrid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `CreateUser_page__TDDiq`,
	"topGrid": `CreateUser_topGrid__rQujk`,
	"cardTitle": `CreateUser_cardTitle__L1epK`,
	"detailGrid": `CreateUser_detailGrid__4VNsc`,
	"field": `CreateUser_field__SXihJ`,
	"label": `CreateUser_label__BIdge`,
	"clientField": `CreateUser_clientField__iXypb`,
	"fieldErr": `CreateUser_fieldErr__Kw+UC`,
	"alert": `CreateUser_alert__3k3ii`,
	"createBtn": `CreateUser_createBtn__uVd4o`,
	"permHint": `CreateUser_permHint__2DxSb`
};
export default ___CSS_LOADER_EXPORT___;
